import { render, staticRenderFns } from "./majorObjectEdit.vue?vue&type=template&id=38e3fe2d"
import script from "./majorObjectEdit.vue?vue&type=script&lang=js"
export * from "./majorObjectEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e3fe2d')) {
      api.createRecord('38e3fe2d', component.options)
    } else {
      api.reload('38e3fe2d', component.options)
    }
    module.hot.accept("./majorObjectEdit.vue?vue&type=template&id=38e3fe2d", function () {
      api.rerender('38e3fe2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/majorObject/majorObjectEdit.vue"
export default component.exports